module.exports = __webpack_public_path__ + "img/29.610487d1.jpg";